import { getModel, Model } from "./models/model";
import { removeDuplicatesFromStringList } from "./strings";

export function runJsTemplate(template:string, value:any, extraData:any) {
	let keys:string[] = [];
	if (extraData) {
		keys = Object.keys(extraData);
	}
	let temp = `return \`${template.replaceAll("`", "\`")}\``;
	let func = new Function("value", ...keys, temp);
	let extraDataArgs = [];
	for (let key of keys) {
		extraDataArgs.push(extraData[key]);
	}
	return func(value, ...extraDataArgs);
}

export function getPreloadsFromJsTemplate(template:string, model:Model):string[] {
	let regex = /\$\{.*\}/g;
	let matches = template.matchAll(regex);
	let result:string[] = [];

	for (let match of matches){
		let content = match[0].substring(0, match[0].length-1).substring(2).trim();
		let preloads = getPreloadFromJsTemplateContent(content, model);
		result.push(...preloads);
	}

	removeDuplicatesFromStringList(result);

	return result;
}


function getPreloadFromJsTemplateContent(content:string, model:Model):string[] {
	let jsExpresionRegex = /(?<=^|[^a-zA-Z0-9\.])value(\.[a-zA-Z0-9]+)*/g; // Looks for value and any property it needs
	let result:string[] = [];
	let matches = content.matchAll(jsExpresionRegex);

	for (let match of matches){
		let parts = match[0].split(".");
		parts.unshift();
		let currentPreload = "";
		let currentModel = model;
		for (let part of parts) {
			let field = currentModel.getField(part);
			if (!field) break;
			if (field.field.type != "has-one" && field.field.type != "has-many") break;
			if (!field.field.modelName) break;
			currentPreload += part + ".";
			currentModel = getModel(field.field.modelName);
		}
		if (currentPreload.endsWith(".")) {
			currentPreload.substring(0, currentPreload.length-1);
		}
		if (!currentPreload) continue;
		result.push(currentPreload);
	}


	return result;
}